import { useEffect, useState } from 'react'
import { Icon } from 'assets/index'
import { MainContainer, Option } from './styles'

interface IProps {
  options: any[]
  setSelected?: any
  placeholder: string
  icon?: any
  selected: any
  dataTestId: string
  isClearable?: boolean
  onChange?: (value: any) => void
  disabled?: boolean
}

const Filter2 = (props: IProps) => {
  const {
    options,
    setSelected,
    icon,
    placeholder,
    selected,
    dataTestId,
    isClearable,
    onChange,
    disabled = false,
  } = props
  const [optFilter, setOptFilter] = useState<any>('')
  const [focused, setFocused] = useState(false)
  const [updatedPlaceholder, setUpdatedPlaceholder] = useState(placeholder)
  const [filteredOptions, setFilteredOptions] = useState(options)

  useEffect(() => {
    setFilteredOptions(
      options.filter(
        (opt) =>
          opt.label && opt.label.toLowerCase().includes(optFilter.toLowerCase())
      )
    )
  }, [optFilter])

  const isSelected = (opt: any) => selected?.value === opt.value
  // Função para verificar se um item já foi selecionado

  useEffect(() => {
    if (selected) {
      setUpdatedPlaceholder(selected.label)
      return
    }
    setUpdatedPlaceholder(placeholder)
  }, [selected])

  return (
    <MainContainer
      isClearable={isClearable}
      selected={selected}
      icon={icon}
      disabled={disabled}
    >
      {icon && <img className="filter-icon" src={icon} alt="filter icon" />}
      <input
        disabled={disabled}
        data-testid={dataTestId}
        className="filter-input"
        type="text"
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setTimeout(() => {
            setOptFilter('')
            setFocused(false)
          }, 300)
        }}
        placeholder={updatedPlaceholder}
        value={optFilter}
        onChange={(e) => {
          setOptFilter(e.target.value)
        }}
      />
      {selected && isClearable && (
        <button
          type="button"
          className="clear-btn"
          onClick={() => {
            setSelected(null)
          }}
        >
          <img
            src={Icon('error.svg')}
            alt="clear icon"
            className="clear-icon"
          />
        </button>
      )}

      <img
        className="chrevon-down"
        src={Icon('chevron_down.svg')}
        alt="filter icon"
      />
      {focused && (
        <div className="menu">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <Option
                data-testid={`option-${opt.label}`}
                type="button"
                key={opt.value}
                className="option"
                value={opt.value}
                isSelected={isSelected(opt)}
                onClick={() => {
                  if (onChange) {
                    onChange(opt)
                    return
                  }
                  setSelected((prevSelected: any) => {
                    // Se a opção já estiver selecionada, deseleciona
                    if (prevSelected?.value === opt.value) {
                      return null // Ou um valor padrão, se necessário
                    }
                    // Caso contrário, seleciona a nova opção
                    return opt
                  })
                }}
              >
                {opt.label}
              </Option>
            ))
          ) : (
            <Option isSelected={false}>Nenhuma opção</Option>
          )}
        </div>
      )}
    </MainContainer>
  )
}

export default Filter2
